<fui-switch-control [label]="'wbo.localisation.label.restricted'" [(ngModel)]="restricted"
                    [disabled]="!forceEnableRestrictions && (readonly || (dataResourceModel.$readonlyChange | async) || !isUserUniversal)"></fui-switch-control>
<ng-container *ngIf="restricted">
    <wbo-localisation-outlet-selection-autocomplete [panelComponent]="panel"
                                                    [readonly]="readonly || (dataResourceModel.$readonlyChange | async)">
    </wbo-localisation-outlet-selection-autocomplete>
    <wbo-localisation-outlet-selection #panel [readonly]="readonly || (dataResourceModel.$readonlyChange | async)"
                                       [selectedOutlets]="localisable.outlets"
                                       [selectedCustomObjects]="localisable.customObjects"
                                       (selectionChanged)="outletSelectionChanged()"></wbo-localisation-outlet-selection>
</ng-container>
